module.exports = __webpack_public_path__ + "images/stickers/taco-proto@2x.552affe7dc91a38348f1.png";